// extracted by mini-css-extract-plugin
export var keyvalues = "KeyValueList-module--keyvalues--28f4a";
export var title = "KeyValueList-module--title--aa7d1";